import * as R from 'ramda';

import { setInDefaultValue } from 'decorators';

function setDefaultInitialValues(input = {}) {
  return R.pipe(
    setInDefaultValue('false', 'application.bankruptcyProceedings'),
    setInDefaultValue('true', 'application.usCitizen'),
  )(input);
}

export { setDefaultInitialValues };
